export default "__VITE_ASSET__54e83f78__"